import { render, staticRenderFns } from "./PrivacyRules.vue?vue&type=template&id=eb0f8366&scoped=true"
import script from "./PrivacyRules.vue?vue&type=script&lang=js"
export * from "./PrivacyRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0f8366",
  null
  
)

export default component.exports